/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsencesState } from '@absences/store/absences.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectAbsencesState = createFeatureSelector<AbsencesState>('absences');

export const getAbsences = createSelector(selectAbsencesState, state => state.absences);
export const getCurrentAbsence = createSelector(selectAbsencesState, state => state.currentAbsence);
export const getAbsenceOwner = createSelector(selectAbsencesState, state => state.owner);
export const getAbsenceClasses = createSelector(selectAbsencesState, state => state.absenceClasses);
export const getSelectableAbsenceClasses = createSelector(
  selectAbsencesState,
  state => state.selectableAbsenceClasses
);
export const isAbsenceActionPending = createSelector(selectAbsencesState, status => status.isActionPending);
